class ComOrderMapper {
  static createModelFromResponse(data) {
    return {
      reference: data.order_reference,
      shipmentReference: data.shipments[0].shipment_reference
    };
  }
  static getCreatePayload(_ref) {
    let {
      payment,
      shipments,
      invoiceRequested,
      carriersTermsAndConditions
    } = _ref;
    return {
      order_custom_reference: 'ref',
      ...(payment.method && payment.type && {
        payment_method_data: {
          is_one_time_payment: true,
          payment_method: payment.method,
          payment_type: payment.type,
          ...(payment.nonce && {
            payment_method_nonce: payment.nonce
          }),
          ...(payment.deviceData && {
            payment_device_data: payment.deviceData
          })
        }
      }),
      shipments,
      invoice_email_requested: invoiceRequested,
      carriers_terms_and_conditions: carriersTermsAndConditions
    };
  }
}

export { ComOrderMapper };
//# sourceMappingURL=ComOrderMapper.js.map
